<template>
  <div class="index-selector">
    <label for="indexInput">Número</label>
    <input
      id="indexInput"
      type="number"
      min="0"
      max="1e6"
      v-model.number="selectedIndex"
      @input="emitIndex"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

interface Props {
  modelValue?: number
}

interface Emits {
  (e: 'index-changed', index: number): void
  (e: 'update:modelValue', index: number): void
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: 1,
})

const emit = defineEmits<Emits>()

const selectedIndex = ref(props.modelValue)

// Emit the index change event
const emitIndex = (): void => {
  emit('index-changed', selectedIndex.value)
  emit('update:modelValue', selectedIndex.value)
}

// Watch for external changes to modelValue
watch(
  () => props.modelValue,
  (newValue) => {
    selectedIndex.value = newValue
  },
)

// Watch for internal changes to selectedIndex
watch(selectedIndex, (newValue) => {
  if (newValue !== props.modelValue) {
    emit('update:modelValue', newValue)
  }
})
</script>

<style scoped>
.index-selector {
  display: flex;
  flex-direction: column;
}

.index-selector label {
  margin-bottom: 4px;
  font-weight: normal;
}

.index-selector input {
  width: 80px;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>
